<template>
  <div>
    <layout menu-item="7">
      <div class="inner-container" v-if="!loading">
        <div class="" style="margin-bottom: 0.5rem">
          <button class="btn btn-danger" @click="save">Speichern</button>
          <span v-if="saved" class="alert alert-success">Gespeichert...</span>
        </div>

        <div class="card">
          <div class="card-body">

            <div class="form-group">
              <label>Aktueller Max Score</label>
              <input class="form-control" v-model.number="scores.maxScore" type="number"/>
            </div>
            <div class="form-group">
              <label>Max Score Update</label>
              <input class="form-control" v-model.number="scores.maxScoreUpdate" type="number"/>
            </div>
          </div>
        </div>

        <div class="card card-width">
          <div class="card-body">
            <div class="card-title">
              Data
            </div>
            <json-textfield ref="settings" :json="settings"/>
          </div>
        </div>

        <div class="card card-width">
          <div class="card-body">
            <div class="card-title">
              Map Styles
            </div>
            <json-textfield ref="mapstyle" :json="mapStyle"/>
          </div>
        </div>

      </div>
    </layout>
  </div>
</template>

<script>

  import Backend from '@/Backend';
  import JsonTextfield from "./JsonTextfield";

  export default {
    components: {JsonTextfield},
    name: "settings",
    data() {
      return {
        values: {},
        settings: {},
        mapStyle: {},
        loading: true,
        saved: false,
        scores: {}

      }
    },
    mounted() {
      this.to = null;
      Backend.instance.getSettings()
        .then((values) => {
          this.values = values;
          this.settings = values.settings || {};
          this.mapStyle = values.mapStyle || {};
          values.maxScore = values.maxScore || 0;
          values.maxScoreUpdate = values.maxScoreUpdate || 0;
          this.loading = false;
        });

      Backend.instance.getMaxScore()
        .then((data) => {
          this.scores = data;
          data.maxScore = data.maxScore || 0;
          data.maxScoreUpdate = data.maxScoreUpdate || 0;
        });
    },
    methods: {
      save() {
        try {
          const update = {
            settings: this.$refs.settings.getData(),
            mapStyle: this.$refs.mapstyle.getData(),
            maxScore: this.values.maxScore,
            maxScoreUpdate: this.values.maxScoreUpdate
          };
          Backend.instance.saveSetting(update).then(() => {
            this.saved = true;
            clearTimeout(this.to);
            this.to = setTimeout(() => {
              this.saved = false;
            }, 1000);
          });

          Backend.instance.saveMaxScore(this.scores.maxScore, this.scores.maxScoreUpdate).then(() => {

          });

        } catch (e) {
        }
      }
    }
  }
</script>

<style scoped>.card-width {
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/settings/Settings.vue